module.exports = __webpack_public_path__ + "static/1_1_reason-2-0262cc7675574802297149a3e7369c31.svg";